import React, { useEffect } from 'react';
import { TopBar, WhatsAppButton, PurchaseNotifications } from '../components/Layout';
import { trackFb } from '../lib/fbpixel';
import { Hero, ArchiveContents, Tension, WhatThisIs, MainCollection } from '../components/Sections';
import { Volumes, Bonuses, Benefits, PostPurchase } from '../components/ContentSections';
import { Authority, Pricing, Guarantee, FAQ, FinalCTA } from '../components/ConversionSections';
export function LandingPage() {
  useEffect(() => {
    // Fire ViewContent when the sales page loads
    trackFb('ViewContent', {
      content_name: 'Colección NOS MIENTEN',
      content_type: 'product',
      currency: 'ARS',
      value: 27990
    });
  }, []);
  return <div className="min-h-screen bg-brand-dark flex flex-col font-sans selection:bg-brand-gold selection:text-brand-dark" data-id="element-218">
      <TopBar data-id="element-219" />

      <main className="flex-1" data-id="element-220">
        <Hero data-id="element-221" />
        <ArchiveContents data-id="element-222" />
        <Tension data-id="element-223" />
        <WhatThisIs data-id="element-224" />
        <MainCollection data-id="element-225" />
        <Volumes data-id="element-226" />
        <Bonuses data-id="element-227" />
        <Benefits data-id="element-228" />
        <PostPurchase data-id="element-229" />
        <Authority data-id="element-230" />
        <Pricing data-id="element-231" />
        <Guarantee data-id="element-232" />
        <FAQ data-id="element-233" />
        <FinalCTA data-id="element-234" />
      </main>

      <footer className="bg-brand-anthracite py-8 border-t border-brand-card text-center px-5" data-id="element-235">
        <p className="text-brand-muted text-xs" data-id="element-236">
          &copy; {new Date().getFullYear()} Colección Nos Mienten. Todos los
          derechos reservados.
        </p>
      </footer>

      <WhatsAppButton data-id="element-237" />
      <PurchaseNotifications data-id="element-238" />
    </div>;
}